import type { CustomEmailProvider } from "../types";

export type AccountForm = {
  displayName: string;
  emailAddress: string;
  providerType: string;
  authType: string;
  incomingProtocol: string;
  incomingServer: string;
  incomingPort: number;
  incomingUseSsl: boolean;
  outgoingServer: string;
  outgoingPort: number;
  outgoingUseSsl: boolean;
  username: string;
  secret: string;
  signatureHtml: string;
  isActive: boolean;
};

export const blankAccount: AccountForm = {
  displayName: "",
  emailAddress: "",
  providerType: "Custom",
  authType: "Password",
  incomingProtocol: "IMAP",
  incomingServer: "",
  incomingPort: 993,
  incomingUseSsl: true,
  outgoingServer: "",
  outgoingPort: 465,
  outgoingUseSsl: true,
  username: "",
  secret: "",
  signatureHtml: "",
  isActive: true
};

export function providerPreset(
  providerType: string,
  current: AccountForm,
  customProviders: CustomEmailProvider[] = []
): AccountForm {
  if (providerType === "Gmail")
    return {
      ...current,
      providerType,
      authType: "AppPassword",
      incomingProtocol: "IMAP",
      incomingServer: "imap.gmail.com",
      incomingPort: 993,
      incomingUseSsl: true,
      outgoingServer: "smtp.gmail.com",
      outgoingPort: 465,
      outgoingUseSsl: true
    };
  if (providerType === "Yahoo")
    return {
      ...current,
      providerType,
      authType: "AppPassword",
      incomingProtocol: "IMAP",
      incomingServer: "imap.mail.yahoo.com",
      incomingPort: 993,
      incomingUseSsl: true,
      outgoingServer: "smtp.mail.yahoo.com",
      outgoingPort: 465,
      outgoingUseSsl: true
    };
  if (providerType === "Demo")
    return {
      ...current,
      providerType,
      authType: "Managed",
      incomingServer: "",
      outgoingServer: "",
      username: "",
      secret: ""
    };

  const custom = customProviders.find((provider) => provider.name === providerType);
  if (custom)
    return {
      ...current,
      providerType: custom.name,
      authType: custom.authType,
      incomingProtocol: custom.incomingProtocol,
      incomingServer: custom.incomingServer,
      incomingPort: custom.incomingPort,
      incomingUseSsl: custom.incomingUseSsl,
      outgoingServer: custom.outgoingServer,
      outgoingPort: custom.outgoingPort,
      outgoingUseSsl: custom.outgoingUseSsl
    };

  return { ...current, providerType, authType: "Password" };
}

export function defaultDisplayName(localPart: string) {
  if (!localPart) return "";
  return localPart.charAt(0).toUpperCase() + localPart.slice(1);
}
